<template>
    <div class="container mx-auto px-5">
        <div
            v-if="!doc.slider"
            class="flex flex-wrap -m-4"
        >
            <div
                v-for="(card, index) in doc.cards"
                :key="index"
                class="w-full sm:w-1/2 lg:w-1/3 p-4"
            >
                <card
                    :image_ratio="doc.image_ratio"
                    :doc="card"
                />
            </div>
        </div>
        <div
            v-else
            class="relative uk-visible-toggle"
            tabindex="-1"
            uk-slider
        >
            <div class="uk-slider-container">
                <ul class="uk-slider-items w-full uk-grid-match">
                    <li
                        v-for="(card, index) in doc.cards"
                        :key="index"
                        class="w-full sm:w-1/2 lg:w-1/3 p-4"
                    >
                        <card
                            :image_ratio="doc.image_ratio"
                            :doc="card"
                        />
                    </li>
                </ul>

                <a
                    class="uk-position-center-left-out -mr-3 md:mr-0"
                    href="#"
                    uk-slider-item="previous"
                >
                    <i class="las la-long-arrow-alt-left strong text-3xl"></i>
                </a>
                <a
                    class="uk-position-center-right-out -ml-3 md:ml-0"
                    href="#"
                    uk-slider-item="next"
                >
                    <i class="las la-long-arrow-alt-right strong text-3xl"></i>
                </a>
            </div>

            <ul class="uk-slider-nav dotnav p-5 flex flex justify-center w-full"></ul>
        </div>
    </div>
</template>

<script>
import Card from "@/components/Card";

export default {
    props: ["doc"],

    components: {
        Card
    },

    created() {
        console.log(this);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Cards.vue